import React from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useAppDispatch } from '../../../redux/hooks';
import { openAuth } from '../../../redux/slice/authModalSlice';
import { setSelectedLeague } from '../../../redux/slice/selectedLeagueSlice';
import { setActiveTab } from '../../../redux/slice/activeTabSlice';
import { getAuthToken } from '../../../helper/helper';
import { mapLeagueItemToGetAllLeagues } from '../../myLeagues/api/myLeaguesApi';
import LeagueCard from '../../myLeagues/components/LeagueCard';
import type { ILeagueItem } from '../../myLeagues/types/myLeagues';
import './MyLeaguesCarousel.scss';
import { IoMdAdd } from "react-icons/io";

interface MyLeaguesCarouselProps {
  leagues: ILeagueItem[];
}

const MyLeaguesCarousel: React.FC<MyLeaguesCarouselProps> = ({ leagues }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleLeagueSelect = (league: ILeagueItem) => {
    dispatch(setSelectedLeague(mapLeagueItemToGetAllLeagues(league)));
    dispatch(setActiveTab('leagues-home'));
    sessionStorage.setItem('activeTab', 'leagues-home');
    navigate('/leagues-home');
  };

  const handleCreateLeague = () => {
    if (!getAuthToken()) {
      toast.error('Please login or signup to create a league.');
      dispatch(openAuth('signin'));
      return;
    }
    navigate('/create-league');
  };

  return (
    <section className="logged-home-my-leagues">
      <h2 className="logged-home-my-leagues-title">My Leagues,</h2>
      <div className="logged-home-my-leagues-wrapper">
        <div className="logged-home-my-leagues-carousel">
          {leagues.map((league) => (
            <div key={league.leagueId} className="logged-home-my-leagues-carousel-item">
              <LeagueCard
                league={league}
                onClick={() => handleLeagueSelect(league)}
              />
            </div>
          ))}
        </div>
        <div className="logged-home-my-leagues-create logged-home-my-leagues-create--static">
          <div className="logged-home-create-league-card">
            <div className="logged-home-create-league-card-icon">
              <IoMdAdd size={20} className="icon" />
            </div>
            <div className="logged-home-create-league-card-content">
              <h3 className="logged-home-create-league-card-title">Create New League</h3>
              <p className="logged-home-create-league-card-subtitle">
                Start Organizing Your Cricket League.
              </p>
            </div>
            <button
              type="button"
              className="logged-home-create-league-card-btn"
              onClick={handleCreateLeague}
            >
              Create League
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MyLeaguesCarousel;
